import createDataReducer from '@ott/create-data-reducer';
import T from './types';

export default createDataReducer([T.GET_HOT_TOURS, T.GET_HOT_TOURS_SUCCESS, T.GET_HOT_TOURS_FAIL]);
